import React from "react";

const Spider = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="1" />
    <path d="M16 16v2l2 4" />
    <path d="M8 16v2l-2 4" />
    <path d="M12 16v6" />
    <path d="M12 8v-5" />
    <path d="M5 4l5 5" />
    <path d="M19 4l-5 5" />
    <path d="M2 12h4" />
    <path d="M18 12h4" />
    <path d="M5 19l5-3" />
    <path d="M19 19l-5-3" />
  </svg>
);

export default Spider;
